module.exports = __webpack_public_path__ + "img/emoji-celebration-80x80.88da4e2b.png";